import React from 'react'
import { Segment, Grid, Form, Image, Icon, Message } from 'semantic-ui-react'
import cclong from '../../images/cclogo-long.png'
import Proptypes from 'prop-types'

const Ad = ({ link, error, remove, onChange }) => {
  return (
    <Segment padded>
      {error && <Message error content="Link must be an https protocol url" />}
      <Grid padded relaxed container centered columns={2}>
        <Grid.Column>
          <Grid.Row>
            <Image size="medium" src={link || cclong} />
          </Grid.Row>
          <Grid.Row>
            <Form.Input
              onChange={onChange}
              value={link}
              icon="linkify"
              iconPosition="left"
              label="Image Link (https)"
              placeholder="https://couchcoach.io/wp-content/uploads/2018/06/CClogoWHITE-300x188.png"
            />
          </Grid.Row>
        </Grid.Column>
        <Grid.Column verticalAlign="top" textAlign="right">
          <Icon size="large" color="red" name="close" onClick={remove} />
        </Grid.Column>
      </Grid>
    </Segment>
  )
}

Ad.propTypes = {
  link: Proptypes.string,
  error: Proptypes.bool,
  remove: Proptypes.func,
  onChange: Proptypes.func
}

export default Ad



// WEBPACK FOOTER //
// ./src/components/Admin/Ad.jsx